export const upperFirst = (words: string, onlyFirst?: boolean) => {
  const separateWord = words.toLowerCase().split(" ");
  for (let i = 0; i < separateWord.length; i++) {
    const index = onlyFirst ? 0 : i;
    const prevWord = separateWord[index] || "";

    separateWord[index] = prevWord.charAt(0).toUpperCase() + prevWord.substring(1);
  }

  return separateWord.join(" ");
};
